import React from 'react';
import './Overview.css';

const Overview = () => {
  const stats = [
    { icon: '🐕', label: 'Total Pets', value: '1,234', color: '#667eea' },
    { icon: '❤️', label: 'Adopted', value: '856', color: '#f5576c' },
    { icon: '🏠', label: 'Available', value: '378', color: '#4ecdc4' },
    { icon: '📝', label: 'My Posts', value: '12', color: '#764ba2' }
  ];

  const recentActivity = [
    { action: 'New pet added', pet: 'Golden Retriever - Max', time: '2 hours ago', type: 'add' },
    { action: 'Adoption request', pet: 'Persian Cat - Luna', time: '5 hours ago', type: 'request' },
    { action: 'Pet adopted', pet: 'Beagle - Buddy', time: '1 day ago', type: 'success' },
    { action: 'New message', pet: 'Regarding Labrador - Bella', time: '2 days ago', type: 'message' }
  ];

  const popularBreeds = [
    { breed: 'Labrador', count: 45, percentage: 85 },
    { breed: 'German Shepherd', count: 38, percentage: 72 },
    { breed: 'Golden Retriever', count: 32, percentage: 60 },
    { breed: 'Beagle', count: 28, percentage: 53 },
    { breed: 'Persian Cat', count: 25, percentage: 47 }
  ];

  return (
    <div className="overview-page">
      <div className="page-header">
        <h1>📊 Dashboard Overview</h1>
        <p>Welcome back! Here's what's happening with pet adoptions today.</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderColor: stat.color }}>
            <div className="stat-icon" style={{ background: `${stat.color}20`, color: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="overview-content">
        <div className="activity-section">
          <h2>Recent Activity</h2>
          <div className="activity-list">
            {recentActivity.map((activity, index) => (
              <div key={index} className={`activity-item ${activity.type}`}>
                <div className="activity-icon">
                  {activity.type === 'add' && '➕'}
                  {activity.type === 'request' && '📋'}
                  {activity.type === 'success' && '✅'}
                  {activity.type === 'message' && '💬'}
                </div>
                <div className="activity-details">
                  <h4>{activity.action}</h4>
                  <p>{activity.pet}</p>
                  <span className="activity-time">{activity.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="breeds-section">
          <h2>Popular Breeds</h2>
          <div className="breeds-list">
            {popularBreeds.map((breed, index) => (
              <div key={index} className="breed-item">
                <div className="breed-header">
                  <span className="breed-name">{breed.breed}</span>
                  <span className="breed-count">{breed.count}</span>
                </div>
                <div className="breed-bar">
                  <div 
                    className="breed-progress" 
                    style={{ width: `${breed.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
